<template>
  <el-config-provider :locale="lang[language]">
    <router-view />
  </el-config-provider>
</template>

<script setup>
import { computed } from "vue";
import { useConfigStore } from "./stores/config";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import en from "element-plus/dist/locale/en.mjs";

const configStore = useConfigStore();
const language = computed(() => configStore.language);
const lang = { zh: zhCn, en };
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  // font-weight: 600;
}
body {
  margin: 0;
  .el-select-dropdown__wrap {
    max-height: 400px;
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: hidden;
  width: 100vw;
}
</style>
